import { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import styles from "./CartFormCards.module.css";
import { CartConfigInterface, UpsellsInterface } from "../../CartTypes";
import { Action, ProductObj, VariantsObj } from "../../../Bundles/Types";
import {
    Button,
    Checkbox,
    Divider,
    FormLayout,
    InlineError,
    Link,
    RadioButton,
    RangeSlider,
    Select,
    Tabs,
    TextField,
    Thumbnail,
} from "@shopify/polaris";
import {
    DISCOUNT_TYPES,
    FontStyles,
    getDiscountOptionsCartUpsells,
    ProductRecommendationIntent,
    UpsellsLayout,
} from "../../../Bundles/constants";
import { asChoiceField, Field } from "@shopify/react-form";
import NewCustomColorPicker from "../../../../components/NewCustomColorPicker/NewCustomColorPicker";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import TextEditorCart from "../../../../components/TextEditorCart/TextEditorCart";
import { DeleteIcon, EditIcon } from "@shopify/polaris-icons";
import CloseIcon from "../../CartIcons/CloseIcon";
import { AppConfigContext } from "../../../../context/AppConfigContext";
import { currencyToSymbols } from "../../../utilities";
import { v4 as uuid } from "uuid";
import { getNumberFieldSuffix } from "../../../../utilities/constants";

const initialCurrentOffer = {
    upsell_offer_type: "all" as "all" | "manual" | "",
    trigger_products: [] as ProductObj[],
    upsell_products: [] as ProductObj[],
    idx: -1,
    discount_value: "10",
    discount_type: DISCOUNT_TYPES.PERCENTAGE,
    apply_discount_on_single_quantity: false,
    cart_upsell_offer_id: uuid(),
};

const ProductLimitOptions = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
];

const ProductRow = ({
    product,
    idx,
    updateKey,
    setCurrentOffer,
}: {
    product: ProductObj;
    idx: number;
    updateKey: string;
    setCurrentOffer: Dispatch<
        SetStateAction<{
            upsell_offer_type: "all" | "manual" | "";
            trigger_products: ProductObj[];
            upsell_products: ProductObj[];
            idx: number;
            discount_value: string;
            discount_type: string;
            cart_upsell_offer_id: string;
        }>
    >;
}) => {
    const removeProduct = () => {
        setCurrentOffer((ps) => {
            const temp = { ...ps };
            // @ts-expect-error hack
            temp[updateKey].splice(idx, 1);
            console._log(temp);
            return temp;
        });
    };
    return (
        <div
            key={product?.variants[0]?.id + idx}
            style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                borderRadius: 10,
                backgroundColor: "white",
                padding: "5px",
            }}
        >
            <div className={styles.productMeta}>
                <div className={styles.productName}>
                    <div className={styles.productImageWrapper}>
                        <img alt={product?.images[0]?.altText} src={product?.images[0]?.originalSrc} style={{}} />
                    </div>
                    <div className={styles.productTitleWrapper}>
                        <div
                            style={{
                                whiteSpace: "normal",
                                cursor: "pointer",
                                textDecoration: "underline",
                            }}
                            onClick={() => {
                                if (shopify.config.shop) {
                                    window.open(`https://${shopify.config.shop}/products/${product?.handle}`, "_blank");
                                }
                            }}
                            className={styles.productTitle}
                        >
                            {product?.title}
                        </div>
                    </div>
                </div>
                <div
                    onClick={() => {
                        removeProduct();
                    }}
                    style={{
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: 10,
                    }}
                >
                    <CloseIcon />
                </div>
            </div>
        </div>
    );
};

const UpsellRow = ({
    _upsell,
    setCurrentOffer,
    setShowMyUpsells,
    idx,
    handleAddOffer,
    currency,
}: {
    idx: number;
    _upsell: any;
    setCurrentOffer: any;
    setShowMyUpsells: any;
    setUpsellModal: any;
    handleAddOffer: any;
    currency: string;
}) => {
    return (
        <tr key={idx}>
            <td>
                {_upsell?.upsell_offer_type === "all"
                    ? "All Products"
                    : _upsell.trigger_products?.length == 1
                      ? `${_upsell.trigger_products?.length} Product`
                      : `${_upsell.trigger_products?.length} Products`}
            </td>
            <td>
                {_upsell?.upsell_products?.length}
                {_upsell.upsell_products?.length === 1 ? " Product" : " Products"}
            </td>
            <td>
                {(() => {
                    if (_upsell.discount_type === DISCOUNT_TYPES.PERCENTAGE) {
                        return `${_upsell.discount_value}% off`;
                    } else if (_upsell.discount_type === DISCOUNT_TYPES.FLAT) {
                        return `${currencyToSymbols[currency]}${_upsell.discount_value} off`;
                    } else if (_upsell.discount_type === DISCOUNT_TYPES.NONE) {
                        return "-";
                    } else {
                        return `-`;
                    }
                })()}
            </td>
            <td>
                <div className={styles.actionButtons}>
                    <Button
                        size="micro"
                        variant={"plain"}
                        onClick={() => {
                            setCurrentOffer({
                                ..._upsell,
                                idx,
                            });
                            setShowMyUpsells(false);
                        }}
                        icon={() => <EditIcon />}
                    ></Button>
                    <Button
                        size={"micro"}
                        variant={"plain"}
                        tone={"critical"}
                        onClick={() => handleAddOffer(idx, true)}
                        icon={() => <DeleteIcon />}
                    ></Button>
                </div>
            </td>
        </tr>
    );
};

const RenderUpsellsOffers = ({
    offers,
    dispatchCartConfig,
}: {
    offers: Field<UpsellsInterface["upsell_offers"]>;
    dispatchCartConfig: Dispatch<Action<CartConfigInterface>>;
}) => {
    const [_offers, setOffers] = useState(offers?.value);
    const [showMyUpsells, setShowMyUpsells] = useState(false);
    const [upsellModal, setUpsellModal] = useState(false);
    const [currentOffer, setCurrentOffer] = useState<{
        upsell_offer_type: "all" | "manual" | "";
        trigger_products: ProductObj[];
        upsell_products: ProductObj[];
        idx: number;
        discount_value: string;
        discount_type: string;
        cart_upsell_offer_id: string;
        apply_discount_on_single_quantity: boolean;
    }>({
        ...initialCurrentOffer,
        cart_upsell_offer_id: uuid(),
    });

    const { currency } = useContext(AppConfigContext);

    useEffect(() => {
        setOffers(offers?.value);
    }, [offers?.value]);

    useEffect(() => {
        if (!currentOffer?.discount_type) {
            setCurrentOffer((ps) => ({
                ...ps,
                discount_type: DISCOUNT_TYPES.NONE,
                discount_value: "10",
            }));
        }
    }, [currentOffer.discount_type]);

    useEffect(() => {
        if (!upsellModal) {
            setCurrentOffer({ ...initialCurrentOffer, cart_upsell_offer_id: uuid() });
        }
    }, [upsellModal]);

    const handleUpsellSave = (updatedArr: any[] | null = null) => {
        offers.onChange(updatedArr ? [...updatedArr] : [..._offers]);
        dispatchCartConfig({
            payload: {
                upsell_offers: updatedArr ? [...updatedArr] : [..._offers],
            },
            isComplex: true,
            key: "upsell",
        });
    };

    const handleAddOffer = (delIdx: number | null = null, updateIdx: number | null = null) => {
        setOffers((ps) => {
            const temp: any[] = [...ps];
            if (delIdx !== null) {
                temp.splice(delIdx, 1); // Remove the element at idx
                handleUpsellSave(temp);
            } else {
                if (updateIdx == -1) {
                    temp.push({
                        upsell_offer_type: currentOffer?.upsell_offer_type,
                        trigger_products: [...currentOffer.trigger_products],
                        upsell_products: [...currentOffer.upsell_products],
                        discount_value: currentOffer?.discount_value,
                        discount_type: currentOffer?.discount_type,
                        apply_discount_on_single_quantity: currentOffer?.apply_discount_on_single_quantity,
                        cart_upsell_offer_id: uuid(),
                    });
                } else {
                    // @ts-expect-error hack
                    temp[updateIdx] = {
                        upsell_offer_type: currentOffer?.upsell_offer_type,
                        trigger_products: [...currentOffer.trigger_products],
                        upsell_products: [...currentOffer.upsell_products],
                        discount_value: currentOffer?.discount_value,
                        discount_type: currentOffer?.discount_type,
                        apply_discount_on_single_quantity: currentOffer?.apply_discount_on_single_quantity,
                        cart_upsell_offer_id: uuid(),
                    };
                }
            }
            handleUpsellSave(temp);
            return temp;
        });
    };

    const handleProductSearch = async (
        key: "trigger_products" | "upsell_products",
        _preSelected: ProductObj[] = [],
        offerIdx: number,
    ) => {
        const preSelected = _preSelected?.map((product: ProductObj) => ({
            id: product?.id,
            variants: product?.variants.map((variant: any) => ({
                id: variant?.id,
            })),
        }));
        const selected = await shopify.resourcePicker({
            type: "product",
            multiple: true,
            query: "",
            action: "select",
            selectionIds: preSelected,
            filter: {
                query: "status:active AND published_status:published",
                variants: false,
            },
        });
        if (selected) {
            const productsArr: ProductObj[] = [];
            selected?.flatMap((product: any) => {
                productsArr.push({
                    id: product?.id,
                    images: product?.images,
                    title: product?.title,
                    handle: product?.handle,
                    quantity: 1,
                    maxProductStock: product?.totalInventory,
                    selectedVariants: [],
                    subscriptions: [],
                    oneTimePurchase: true,
                    isSubscribed: false,
                    variants: product?.variants?.map((variant: VariantsObj) => ({
                        image: { ...variant.image },
                        id: variant?.id,
                        displayName: variant.displayName,
                        title: variant?.title?.toLowerCase() == "default title" ? product?.title : variant?.title,
                        price: variant?.price,
                        quantity: 1,
                        selectedOptions: variant?.selectedOptions,
                        copyPrice: variant.price,
                        compareAtPrice: variant.compareAtPrice ? variant.compareAtPrice : variant.price,
                    })),
                    options: product?.options,
                });
            });
            if (offerIdx == -1) {
                setCurrentOffer((ps) => ({ ...ps, [key]: [...productsArr] }));
            } else {
                setOffers((ps) => {
                    const temp = [...ps];
                    temp[offerIdx][key] = [...productsArr];
                    return temp;
                });
            }
        }
    };

    const tabs = [
        {
            id: "1",
            content: currentOffer?.idx == -1 ? "Create" : "Update",
            panelID: "1",
        },
        {
            id: "2",
            content: <>My Upsells {_offers?.length > 0 && _offers?.length}</>,
            panelID: "2",
        },
    ];

    const handleTabChange = (i: number) => {
        if (i == 0) {
            if (currentOffer?.idx == -1) {
                setCurrentOffer({
                    ...initialCurrentOffer,
                    cart_upsell_offer_id: uuid(),
                });
            }
            setShowMyUpsells(false);
        } else {
            setShowMyUpsells(true);
            setCurrentOffer({
                ...initialCurrentOffer,
                cart_upsell_offer_id: uuid(),
            });
        }
    };

    return (
        <>
            <div className={`${styles.formRow} ${styles.row1}`} style={{ marginTop: -14 }}>
                {offers?.value?.length > 0 ? (
                    <div className={styles.upsellsCta}>
                        <Button
                            onClick={() => {
                                setShowMyUpsells(false);
                                setUpsellModal(true);
                            }}
                            variant={"primary"}
                        >
                            Create Upsells
                        </Button>
                        <Button
                            onClick={() => {
                                setShowMyUpsells(true);
                                setUpsellModal(true);
                            }}
                            variant={"secondary"}
                        >
                            My Upsells
                        </Button>
                    </div>
                ) : (
                    <div
                        className={styles.noUpsells}
                        onClick={() => {
                            setCurrentOffer({
                                ...initialCurrentOffer,
                                cart_upsell_offer_id: uuid(),
                            });
                            setShowMyUpsells(false);
                            setUpsellModal(true);
                        }}
                    >
                        <Button variant={"secondary"} size={"micro"}>
                            {"Create Upsells"}
                        </Button>
                    </div>
                )}
            </div>
            <CustomModal
                title={"Configure Manual Upsell"}
                open={upsellModal}
                onClose={() => {
                    setUpsellModal(false);
                }}
                primaryAction={
                    showMyUpsells
                        ? {
                              content: "Update",
                              onAction: () => {
                                  handleUpsellSave();
                                  setUpsellModal(false);
                              },
                          }
                        : {
                              disabled:
                                  currentOffer?.upsell_products?.length == 0 ||
                                  (currentOffer?.upsell_offer_type == "manual" &&
                                      currentOffer?.trigger_products?.length == 0),
                              content: currentOffer?.idx == -1 ? "Create" : "Update",
                              onAction: () => {
                                  handleAddOffer(null, currentOffer?.idx);
                                  if (currentOffer?.idx == -1) {
                                      setShowMyUpsells(true);
                                  } else {
                                      setUpsellModal(false);
                                  }
                              },
                          }
                }
                secondaryActions={[
                    {
                        content: "Cancel",
                        onAction: () => setUpsellModal(false),
                    },
                ]}
            >
                <div className={styles.upsellConfigureModalWrapper}>
                    <Tabs
                        // @ts-expect-error required
                        tabs={tabs}
                        selected={showMyUpsells ? 1 : 0}
                        onSelect={handleTabChange}
                    ></Tabs>

                    <div className={styles.upsellRenderTab}>
                        {showMyUpsells ? (
                            <div className={styles.renderMyUpsells}>
                                <div className={styles.upsellTableWrapper}>
                                    {_offers.length ? (
                                        <table className={styles.upsellTable}>
                                            <thead>
                                                <tr>
                                                    <th>Trigger Products</th>
                                                    <th>Upsell Products</th>
                                                    <th>Discount</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {_offers?.map((_upsell, idx: number) => (
                                                    <UpsellRow
                                                        idx={idx}
                                                        _upsell={_upsell}
                                                        setCurrentOffer={setCurrentOffer}
                                                        setUpsellModal={setUpsellModal}
                                                        setShowMyUpsells={setShowMyUpsells}
                                                        handleAddOffer={handleAddOffer}
                                                        currency={currency}
                                                    />
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <div className={styles.noUpsells} style={{ border: "none" }}>
                                            <Button
                                                variant={"secondary"}
                                                size={"micro"}
                                                onClick={() => {
                                                    setShowMyUpsells(false);
                                                    setCurrentOffer({
                                                        ...initialCurrentOffer,
                                                        cart_upsell_offer_id: uuid(),
                                                    });
                                                }}
                                            >
                                                {"Create Upsells"}
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div style={{ width: "100%" }}>
                                <div className={styles.triggerProductsSelection}>
                                    <div className={styles.sectionLabel}>Trigger Products</div>
                                    <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                        <RadioButton
                                            label={"All Products"}
                                            name={"trigger_all"}
                                            value={"all"}
                                            checked={currentOffer?.upsell_offer_type == "all"}
                                            onChange={() => {
                                                setCurrentOffer((ps) => ({
                                                    ...ps,
                                                    upsell_offer_type: "all",
                                                }));
                                            }}
                                        />
                                        <RadioButton
                                            label={"Specific Product"}
                                            name={"trigger_all"}
                                            checked={currentOffer?.upsell_offer_type == "manual"}
                                            value={"manual"}
                                            onChange={() => {
                                                setCurrentOffer((ps) => ({ ...ps, upsell_offer_type: "manual" }));
                                            }}
                                        />
                                        {currentOffer?.upsell_offer_type == "manual" && (
                                            <>
                                                {currentOffer?.trigger_products.length ? (
                                                    <div className={styles.upsellProducts}>
                                                        {currentOffer?.trigger_products.map((tp, index) => (
                                                            <ProductRow
                                                                product={tp}
                                                                idx={index}
                                                                updateKey={"trigger_products"}
                                                                setCurrentOffer={setCurrentOffer}
                                                            />
                                                        ))}
                                                        <div className={styles.addProductsSticky}>
                                                            <>
                                                                <span className={styles.emptySpacer}></span>
                                                                <Button
                                                                    variant={"secondary"}
                                                                    size={"micro"}
                                                                    onClick={() =>
                                                                        handleProductSearch(
                                                                            "trigger_products",
                                                                            currentOffer?.trigger_products,
                                                                            -1,
                                                                        )
                                                                    }
                                                                >
                                                                    {"Add Trigger Products"}
                                                                </Button>
                                                                <span className={styles.emptySpacer}></span>
                                                            </>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className={styles.noUpsells}
                                                        onClick={() =>
                                                            handleProductSearch(
                                                                "trigger_products",
                                                                currentOffer?.trigger_products,
                                                                -1,
                                                            )
                                                        }
                                                    >
                                                        <Button variant={"secondary"} size={"micro"}>
                                                            {"Add Trigger Products"}
                                                        </Button>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                                <br />
                                <div className={styles.upsellProductsSelection}>
                                    <div className={styles.sectionLabel}>Upsell Products</div>
                                    {currentOffer?.upsell_products.length ? (
                                        <div className={styles.upsellProducts}>
                                            {currentOffer?.upsell_products.map((up, index) => (
                                                <ProductRow
                                                    product={up}
                                                    idx={index}
                                                    updateKey={"upsell_products"}
                                                    setCurrentOffer={setCurrentOffer}
                                                />
                                            ))}
                                            <div className={styles.addProductsSticky}>
                                                <span className={styles.emptySpacer}></span>
                                                <Button
                                                    variant={"secondary"}
                                                    size={"micro"}
                                                    onClick={() =>
                                                        handleProductSearch(
                                                            "upsell_products",
                                                            currentOffer?.upsell_products,
                                                            -1,
                                                        )
                                                    }
                                                >
                                                    {"Add Upsells Products"}
                                                </Button>
                                                <span className={styles.emptySpacer}></span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            className={styles.noUpsells}
                                            onClick={() =>
                                                handleProductSearch(
                                                    "upsell_products",
                                                    currentOffer?.upsell_products,
                                                    -1,
                                                )
                                            }
                                        >
                                            <Button variant={"secondary"} size={"micro"}>
                                                {"Add Upsells Products"}
                                            </Button>
                                        </div>
                                    )}
                                </div>
                                <br />
                                <div className={styles.upsellProductsSelection}>
                                    <div className={styles.sectionLabel}>Discounts</div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <div style={{ width: "48%" }}>
                                            <Select
                                                label={"Discount Type"}
                                                placeholder={"Select discount type"}
                                                options={getDiscountOptionsCartUpsells(currencyToSymbols[currency])}
                                                onChange={(value: any) => {
                                                    setCurrentOffer((ps) => ({
                                                        ...ps,
                                                        discount_type: value,
                                                        discount_value:
                                                            value == "percentage" && +ps.discount_value > 100
                                                                ? 100
                                                                : (ps.discount_value as any),
                                                    }));
                                                }}
                                                value={currentOffer.discount_type}
                                            />
                                        </div>
                                        {currentOffer.discount_type !== DISCOUNT_TYPES.NONE && (
                                            <div style={{ width: "48%" }}>
                                                <TextField
                                                    type={"number"}
                                                    label={"Value"}
                                                    placeholder="value"
                                                    min={1}
                                                    max={currentOffer.discount_type == "percentage" ? 100 : ""}
                                                    value={currentOffer.discount_value?.toString()}
                                                    suffix={
                                                        getNumberFieldSuffix(
                                                            currentOffer.discount_type,
                                                            currency,
                                                            currencyToSymbols[currency],
                                                        ).suffix
                                                    }
                                                    onBlur={() => {}}
                                                    autoComplete="off"
                                                    onChange={(value) => {
                                                        const regex = /^(\d+(\.\d{0,2})?)?$/;
                                                        if (regex.test(value)) {
                                                            let val = +value;
                                                            if (
                                                                currentOffer.discount_type === "percentage" &&
                                                                +val > 100
                                                            ) {
                                                                val = 100;
                                                            }
                                                            setCurrentOffer((ps) => ({
                                                                ...ps,
                                                                discount_value: val as any,
                                                            }));
                                                        }
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div style={{ marginTop: "10px" }}>
                                        <Checkbox
                                            label={"Apply discount on single quantity of upsells"}
                                            checked={currentOffer?.apply_discount_on_single_quantity}
                                            onChange={(val) => {
                                                setCurrentOffer((ps) => ({
                                                    ...ps,
                                                    apply_discount_on_single_quantity: val,
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </CustomModal>
        </>
    );
};

const CartUpsellsForm = ({
    fields,
    dispatchCartConfig,
    showCartPreview,
}: {
    fields: any;
    showCartPreview: boolean;
    dispatchCartConfig: Dispatch<Action<CartConfigInterface>>;
}) => {
    const {
        upsell: {
            upsell_products_type,
            recommendation_algorithm,
            exclude_ai_recommendation_products,
            show_if_item_in_cart,
            limit_upsells_in_cart,
            upsell_triggered_product_required,
            max_upsell_items,
            upsell_title,
            upsell_layout,
            upsell_layout_dir,
            is_upsell_sticky,
            upsell_offers,
            limit_visible_upsells_in_cart,
            visible_upsell_limit,
        },
        upsell_design: {
            upsell_bg_color,
            upsell_title_color,
            upsell_product_bg_color,
            upsell_product_border_color,
            upsell_product_text_color,
            upsell_product_title_size,
            upsell_product_title_style,
            upsell_product_discount_text_color,
            upsell_button_radius,
            upsell_card_radius,
            upsell_title_size,
            upsell_price_size,
            upsell_price_style,
            upsell_compared_price_size,
            upsell_compared_price_style,
            upsell_discount_size,
            upsell_discount_style,
            upsell_button_bg_color,
            upsell_button_text_color,
            upsell_button_border_color,
            upsell_button_hover_border_color,
            upsell_button_bg_hover_color,
            upsell_button_text_hover_color,
        },
    } = fields;

    return (
        <>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Upsell Product</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${styles.row1}`}>
                        <RadioButton
                            label={"AI Recommendations"}
                            helpText={
                                upsell_products_type.value == "manual" ? (
                                    <></>
                                ) : recommendation_algorithm.value == ProductRecommendationIntent.RELATED ? (
                                    <>
                                        You can know more about this algorithm{" "}
                                        <Link
                                            url={
                                                "https://shopify.dev/docs/storefronts/themes/product-merchandising/recommendations/related-products"
                                            }
                                            target="_blank"
                                        >
                                            here
                                        </Link>
                                    </>
                                ) : (
                                    <>
                                        Complementary products need to be manually set up using the{" "}
                                        <Link
                                            url={
                                                "https://shopify.dev/docs/storefronts/themes/product-merchandising/recommendations#recommendation-intents"
                                            }
                                            target="_blank"
                                        >
                                            Shopify Search & Discovery app
                                        </Link>
                                    </>
                                )
                            }
                            name={"all"}
                            {...asChoiceField(upsell_products_type, "all")}
                            onChange={() => {
                                const val = "all";
                                dispatchCartConfig({
                                    isComplex: true,
                                    payload: {
                                        upsell_products_type: val,
                                    },
                                    key: "upsell",
                                });
                                upsell_products_type.onChange(val);
                                dispatchCartConfig({
                                    isComplex: true,
                                    payload: {
                                        upsell_offers: [],
                                    },
                                    key: "upsell",
                                });
                                upsell_offers.onChange([]);
                            }}
                        />
                    </div>
                    {upsell_products_type.value === "all" && (
                        <div className={`${styles.formRow} ${styles.row1}`} style={{ marginTop: -14, paddingLeft: 26 }}>
                            <Select
                                label={"Recommendation Algorithm"}
                                labelHidden
                                options={[
                                    { label: "Related", value: ProductRecommendationIntent.RELATED },
                                    { label: "Complimentary", value: ProductRecommendationIntent.COMPLEMENTARY },
                                ]}
                                placeholder={"Select Recommendation Algorithm"}
                                onChange={(val) => {
                                    recommendation_algorithm.onChange(val);
                                    dispatchCartConfig({
                                        payload: {
                                            recommendation_algorithm: val,
                                        },
                                        isComplex: true,
                                        key: "upsell",
                                    });
                                }}
                                value={recommendation_algorithm.value}
                            />
                        </div>
                    )}
                    {upsell_products_type.value === "all" && (
                        <ExcludeAIRecommendationProducts
                            exclude_ai_recommendation_products={exclude_ai_recommendation_products}
                            dispatchCartConfig={dispatchCartConfig}
                        />
                    )}
                    <div className={`${styles.formRow} ${styles.row1}`} style={{ marginTop: -10 }}>
                        <RadioButton
                            label={"Manual Upsells"}
                            helpText={"Manually select products to upsell, ensuring they align with your strategy."}
                            name={"manual"}
                            {...asChoiceField(upsell_products_type, "manual")}
                            onChange={() => {
                                const val = "manual";
                                dispatchCartConfig({
                                    isComplex: true,
                                    payload: {
                                        upsell_products_type: val,
                                    },
                                    key: "upsell",
                                });
                                upsell_products_type.onChange(val);
                            }}
                        />
                    </div>
                    {upsell_products_type.value === "manual" && (
                        <>
                            <RenderUpsellsOffers offers={upsell_offers} dispatchCartConfig={dispatchCartConfig} />
                            <InlineError message={upsell_offers.error} fieldID="upsell_offers" />
                        </>
                    )}
                </FormLayout>
            </div>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Upsell General Settings</div>
                <FormLayout>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                        }}
                    >
                        <div className={`${styles.formRow} ${styles.row1}`}>
                            <Checkbox
                                label={"Show upsell offers for products already in the cart"}
                                {...show_if_item_in_cart}
                                value=""
                                checked={show_if_item_in_cart.value}
                                onChange={(val) => {
                                    dispatchCartConfig({
                                        payload: {
                                            show_if_item_in_cart: val,
                                        },
                                        isComplex: true,
                                        key: "upsell",
                                    });
                                    show_if_item_in_cart.onChange(val);
                                }}
                            />
                        </div>
                        {upsell_products_type?.value == "manual" && (
                            <div className={`${styles.formRow} ${styles.row1}`}>
                                <Checkbox
                                    label={"Apply upsell discount only if triggered products are in the cart"}
                                    {...upsell_triggered_product_required}
                                    value=""
                                    checked={upsell_triggered_product_required.value}
                                    onChange={(val) => {
                                        dispatchCartConfig({
                                            payload: {
                                                upsell_triggered_product_required: val,
                                            },
                                            isComplex: true,
                                            key: "upsell",
                                        });
                                        upsell_triggered_product_required.onChange(val);
                                    }}
                                />
                            </div>
                        )}
                        <div className={styles.formRow}>
                            <div>
                                <Checkbox
                                    label={"Maximum upsell products to show"}
                                    {...limit_upsells_in_cart}
                                    value=""
                                    checked={limit_upsells_in_cart.value}
                                    onChange={(val) => {
                                        dispatchCartConfig({
                                            payload: {
                                                limit_upsells_in_cart: val,
                                            },
                                            isComplex: true,
                                            key: "upsell",
                                        });
                                        limit_upsells_in_cart.onChange(val);
                                    }}
                                />
                            </div>
                            {limit_upsells_in_cart.value && (
                                <div className={`${styles.formRow} ${styles.row4}`}>
                                    <Select
                                        // label={"Maximum upsell items to show"}
                                        options={ProductLimitOptions}
                                        // placeholder={"Upsell limit"}
                                        onChange={(val) => {
                                            max_upsell_items.onChange(+val);
                                            dispatchCartConfig({
                                                payload: {
                                                    max_upsell_items: +val,
                                                },
                                                isComplex: true,
                                                key: "upsell",
                                            });
                                        }}
                                        value={max_upsell_items.value + ""}
                                    />
                                </div>
                            )}
                        </div>
                        <div className={styles.formRow}>
                            <div>
                                <Checkbox
                                    label={"Limit how many upsell items a customer can add"}
                                    {...limit_visible_upsells_in_cart}
                                    value=""
                                    checked={limit_visible_upsells_in_cart.value}
                                    onChange={(val) => {
                                        dispatchCartConfig({
                                            payload: {
                                                limit_visible_upsells_in_cart: val,
                                            },
                                            isComplex: true,
                                            key: "upsell",
                                        });
                                        limit_visible_upsells_in_cart.onChange(val);
                                    }}
                                />
                            </div>
                            {limit_visible_upsells_in_cart.value && (
                                <div className={`${styles.formRow} ${styles.row4}`}>
                                    <Select
                                        // label={"Maximum upsell items to show"}
                                        options={ProductLimitOptions}
                                        // placeholder={"Upsell limit"}
                                        onChange={(val) => {
                                            visible_upsell_limit.onChange(+val);
                                            dispatchCartConfig({
                                                payload: {
                                                    visible_upsell_limit: +val,
                                                },
                                                isComplex: true,
                                                key: "upsell",
                                            });
                                        }}
                                        value={visible_upsell_limit.value + ""}
                                    />
                                </div>
                            )}
                        </div>

                        <div className={`${styles.formRow}`}>
                            <Select
                                label={"Upsell Layout"}
                                options={UpsellsLayout}
                                placeholder={"Upsells Layout"}
                                onChange={(val) => {
                                    upsell_layout.onChange(val);
                                    dispatchCartConfig({
                                        payload: {
                                            upsell_layout: val,
                                        },
                                        isComplex: true,
                                        key: "upsell",
                                    });
                                }}
                                value={upsell_layout.value}
                            />
                            {upsell_layout.value == "carousel" && (
                                <Select
                                    label={"Carousel View Type"}
                                    options={[
                                        { label: "Horizontal", value: "horizontal" },
                                        { label: "Vertical", value: "vertical" },
                                    ]}
                                    placeholder={"Carousel Layout"}
                                    onChange={(val) => {
                                        upsell_layout_dir.onChange(val);
                                        dispatchCartConfig({
                                            payload: {
                                                upsell_layout_dir: val,
                                            },
                                            isComplex: true,
                                            key: "upsell",
                                        });
                                    }}
                                    value={upsell_layout_dir.value}
                                />
                            )}
                        </div>
                        <div className={`${styles.formRow} ${styles.row1}`}>
                            <Checkbox
                                label={"Make upsell sticky"}
                                {...is_upsell_sticky}
                                value=""
                                checked={is_upsell_sticky.value}
                                onChange={(val) => {
                                    dispatchCartConfig({
                                        payload: {
                                            is_upsell_sticky: val,
                                        },
                                        isComplex: true,
                                        key: "upsell",
                                    });
                                    is_upsell_sticky.onChange(val);
                                }}
                            />
                        </div>
                    </div>
                </FormLayout>
            </div>
            <div className={styles.designCardWrapper} style={{ paddingBottom: 10 }}>
                <div className={styles.cardLabel}>Upsell Texts Settings</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${styles.row1}`}>
                        <TextEditorCart
                            placeholder="Place your subtext here"
                            value={upsell_title.value}
                            onChange={(value: any) => {
                                const cleanedValue = value === "<p><br></p>" ? "" : value;
                                upsell_title.onChange(cleanedValue);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_title: cleanedValue,
                                    },
                                    isComplex: true,
                                    key: "upsell",
                                });
                            }}
                            submit={() => upsell_title?.runValidation()}
                            error={upsell_title.error}
                        />
                    </div>
                </FormLayout>
            </div>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Typography</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Upsell Text Size"}
                            placeholder={"13"}
                            value={upsell_title_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        upsell_title_size: +value,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                                upsell_title_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={upsell_title_size.error}
                            onBlur={upsell_title_size?.onBlur}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel}>Upsell Product Title</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={upsell_product_title_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        upsell_product_title_size: +value,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                                upsell_product_title_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={upsell_product_title_size.error}
                            onBlur={upsell_product_title_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font style"}
                            onChange={(val) => {
                                upsell_product_title_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_product_title_style: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            value={upsell_product_title_style.value}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel}>Upsell Product Price</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={upsell_price_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        upsell_price_size: +value,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                                upsell_price_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={upsell_price_size.error}
                            onBlur={upsell_price_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font style"}
                            onChange={(val) => {
                                upsell_price_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_price_style: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            value={upsell_price_style.value}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel}>Upsell Product Compare-at Price</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={upsell_compared_price_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        upsell_compared_price_size: +value,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                                upsell_compared_price_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={upsell_compared_price_size.error}
                            onBlur={upsell_compared_price_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font style"}
                            onChange={(val) => {
                                upsell_compared_price_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_compared_price_style: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            value={upsell_compared_price_style.value}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel}>Upsell Product Discount Text</div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <TextField
                            label={"Size"}
                            placeholder={"13"}
                            value={upsell_discount_size?.value?.toString()}
                            type={"number"}
                            onChange={(value) => {
                                dispatchCartConfig({
                                    payload: {
                                        upsell_discount_size: +value,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                                upsell_discount_size.onChange(+value);
                            }}
                            min={0}
                            autoComplete="off"
                            error={upsell_discount_size.error}
                            onBlur={upsell_discount_size?.onBlur}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font style"}
                            onChange={(val) => {
                                upsell_discount_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_discount_style: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            value={upsell_discount_style.value}
                        />
                    </div>
                </FormLayout>
            </div>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Color</div>
                <FormLayout>
                    <div className={styles.cardSubLabel} style={{ marginBottom: -10 }}>
                        Upsell Section Background & Structure
                    </div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <NewCustomColorPicker
                            hexColor={upsell_bg_color.value}
                            setHexColor={(val) => {
                                upsell_bg_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_bg_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Upsell Background"}
                            props={{
                                ...upsell_bg_color,
                                onBlur: () => upsell_bg_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={upsell_product_bg_color.value}
                            setHexColor={(val) => {
                                upsell_product_bg_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_product_bg_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Upsell Product Background"}
                            props={{
                                ...upsell_product_bg_color,
                                onBlur: () => upsell_product_bg_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={upsell_product_border_color.value}
                            setHexColor={(val) => {
                                upsell_product_border_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_product_border_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Upsell Product Border"}
                            props={{
                                ...upsell_product_border_color,
                                onBlur: () => upsell_product_border_color?.runValidation(),
                            }}
                        />
                        <RangeSlider
                            min={0}
                            max={100}
                            label="Card Border Radius"
                            value={upsell_card_radius.value}
                            onChange={(val) => {
                                upsell_card_radius.onChange(+val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_card_radius: +val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            output
                            suffix={(upsell_card_radius.value || 0) + "px"}
                            error={upsell_card_radius.error}
                        />
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel} style={{ marginBottom: -10 }}>
                        Upsell Text Content
                    </div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <NewCustomColorPicker
                            hexColor={upsell_title_color.value}
                            setHexColor={(val) => {
                                upsell_title_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_title_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Upsell Title"}
                            props={{
                                ...upsell_title_color,
                                onBlur: () => upsell_title_color?.runValidation(),
                            }}
                        />

                        <NewCustomColorPicker
                            hexColor={upsell_product_text_color.value}
                            setHexColor={(val) => {
                                upsell_product_text_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_product_text_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Upsell Product Text"}
                            props={{
                                ...upsell_product_text_color,
                                onBlur: () => upsell_product_text_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={upsell_product_discount_text_color.value}
                            setHexColor={(val) => {
                                upsell_product_discount_text_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_product_discount_text_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Upsell Product Discount Text"}
                            props={{
                                ...upsell_product_discount_text_color,
                                onBlur: () => upsell_product_discount_text_color?.runValidation(),
                            }}
                        />

                        {/* <NewCustomColorPicker
                            hexColor={swatches_select_color.value}
                            setHexColor={(val) => {
                                swatches_select_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        swatches_select_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Swatches Color"}
                            props={{
                                ...swatches_select_color,
                                onBlur: submit,
                            }}
                        /> */}
                    </div>
                    <Divider />
                    <div className={styles.cardSubLabel} style={{ marginBottom: -10 }}>
                        Button Design
                    </div>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <NewCustomColorPicker
                            hexColor={upsell_button_bg_color.value}
                            setHexColor={(val) => {
                                upsell_button_bg_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_button_bg_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Button Background"}
                            props={{
                                ...upsell_button_bg_color,
                                onBlur: () => upsell_button_bg_color?.runValidation(),
                            }}
                        />

                        <NewCustomColorPicker
                            hexColor={upsell_button_bg_hover_color.value}
                            setHexColor={(val) => {
                                upsell_button_bg_hover_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_button_bg_hover_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Button Hover Background"}
                            props={{
                                ...upsell_button_bg_hover_color,
                                onBlur: () => upsell_button_bg_hover_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={upsell_button_text_color.value}
                            setHexColor={(val) => {
                                upsell_button_text_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_button_text_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Button Text"}
                            props={{
                                ...upsell_button_text_color,
                                onBlur: () => upsell_button_text_color?.runValidation(),
                            }}
                        />

                        <NewCustomColorPicker
                            hexColor={upsell_button_text_hover_color.value}
                            setHexColor={(val) => {
                                upsell_button_text_hover_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_button_text_hover_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Button Hover Text"}
                            props={{
                                ...upsell_button_text_hover_color,
                                onBlur: () => upsell_button_text_hover_color?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={upsell_button_border_color.value}
                            setHexColor={(val) => {
                                upsell_button_border_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_button_border_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Button Border"}
                            props={{
                                ...upsell_button_border_color,
                                onBlur: () => upsell_button_border_color?.runValidation(),
                            }}
                        />

                        <NewCustomColorPicker
                            hexColor={upsell_button_hover_border_color.value}
                            setHexColor={(val) => {
                                upsell_button_hover_border_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_button_hover_border_color: val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            label={"Button Hover Border"}
                            props={{
                                ...upsell_button_hover_border_color,
                                onBlur: () => upsell_button_hover_border_color?.runValidation(),
                            }}
                        />
                        <RangeSlider
                            min={0}
                            max={100}
                            label="Button Border Radius"
                            value={upsell_button_radius.value}
                            onChange={(val) => {
                                upsell_button_radius.onChange(+val);
                                dispatchCartConfig({
                                    payload: {
                                        upsell_button_radius: +val,
                                    },
                                    isComplex: true,
                                    key: "upsell_design",
                                });
                            }}
                            output
                            suffix={(upsell_button_radius.value || 0) + "px"}
                            error={upsell_button_radius.error}
                        />
                    </div>
                </FormLayout>
            </div>
        </>
    );
};

const ExcludeAIRecommendationProducts = ({
    exclude_ai_recommendation_products,
    dispatchCartConfig,
}: {
    exclude_ai_recommendation_products: any;
    dispatchCartConfig: any;
}) => {
    const { sft, shop } = useContext(AppConfigContext);

    const [excludeAIRecommendation, setExcludeAIRecommendation] = useState(
        !!exclude_ai_recommendation_products.value.length,
    );

    const [productsSelected, setProductsSelected] = useState<any>([]);

    const openResourcePicker = async () => {
        const selected = await shopify.resourcePicker({
            type: "product",
            multiple: true,
            action: "select",
            selectionIds: exclude_ai_recommendation_products.value.map((id: number) => ({
                id: "gid://shopify/Product/" + id,
            })),
            filter: {
                variants: false,
                query: "status:active AND published_status:published",
            },
        });

        if (selected) {
            const ids = selected.flatMap((p) => +(p.id.split("/").pop() || 0));
            exclude_ai_recommendation_products.onChange(ids);
            dispatchCartConfig({
                payload: {
                    exclude_ai_recommendation_products: ids,
                },
                isComplex: true,
                key: "upsell",
            });
        }
    };

    useEffect(() => {
        async function loadProductsInfo() {
            const query = `query GetProducts($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Product {
      id
      title
      images(first: 10) {
        nodes {
          originalSrc
        }
      }
    }
  }
}`;

            const requestOptions: RequestInit = {
                method: "post",
                headers: {
                    "X-Shopify-Storefront-Access-Token": sft,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    variables: {
                        ids: exclude_ai_recommendation_products.value.map(
                            (id: number) => "gid://shopify/Product/" + id,
                        ),
                    },
                    query,
                }),
            };

            const response = await fetch(`https://${shop}.myshopify.com/api/2026-04/graphql.json`, requestOptions);

            const result = await response.json();

            if (result?.data?.nodes) {
                setProductsSelected(result.data.nodes);
                setExcludeAIRecommendation(true);
            }
        }
        if (exclude_ai_recommendation_products.value.length) loadProductsInfo();
        else setProductsSelected([]);
    }, [exclude_ai_recommendation_products.value]);

    return (
        <div style={{ marginLeft: 25 }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 10,
                }}
            >
                <Checkbox
                    label={"Exclude Products from AI Recommendation."}
                    checked={excludeAIRecommendation}
                    onChange={(val) => {
                        if (val == true) {
                            openResourcePicker();
                        } else {
                            exclude_ai_recommendation_products.onChange([]);
                            dispatchCartConfig({
                                payload: {
                                    exclude_ai_recommendation_products: [],
                                },
                                isComplex: true,
                                key: "upsell",
                            });

                            setExcludeAIRecommendation(false);
                        }
                    }}
                />
                {exclude_ai_recommendation_products?.value?.length ? (
                    <Button onClick={openResourcePicker} icon={() => <EditIcon />}>
                        Edit Products
                    </Button>
                ) : null}
            </div>

            {excludeAIRecommendation ? (
                <>
                    {exclude_ai_recommendation_products?.value?.length ? (
                        <div style={{ border: "1px lightgray solid", borderRadius: 15, padding: 5 }}>
                            {productsSelected.slice(0, 3).map((p) => (
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 20,
                                        padding: 5,
                                    }}
                                >
                                    <Thumbnail source={p?.images.nodes[0]?.originalSrc} alt={p?.title} size={"small"} />
                                    <p>{p?.title}</p>
                                </div>
                            ))}

                            {exclude_ai_recommendation_products.value.length > 3 ? (
                                <div style={{ padding: 10, fontSize: 12, fontWeight: 600 }}>
                                    +{exclude_ai_recommendation_products.value.length - 3} more products
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                    ) : null}
                </>
            ) : (
                ""
            )}
        </div>
    );
};

export default CartUpsellsForm;
